import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  id?: string;
};

/** Validierungsfehler – blockiert den Buchungsabschluss. */
export function FieldError({ children, id }: Props) {
  return (
    <p
      id={id}
      className="mt-1.5 rounded-md border border-red-200 bg-red-50 px-2.5 py-1.5 text-xs leading-relaxed text-red-800"
      role="alert"
    >
      {children}
    </p>
  );
}
